import React, { useEffect, useState } from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Menu,
  MenuItem,
} from '@material-ui/core';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { MoreHoriz } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import {
  DASHBOARD_REST_TABLES_INFO_CREATE,
  DASHBOARD_REST_TABLES_INFO_DETAILS,
  DASHBOARD_REST_TABLES_VIEW,
  RES_TABLE_FILTER,
  RES_TABLE_STATUS,
  TABLE_STATUS_NOBOOKINGS,
  TABLE_STATUS_VACANT,
} from '../../../../../constants/DashboardConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_RESTAURANT,
} from '../../../../../constants/RoleConsts';
import './DashboardRestaurantTableInfoList.scss';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import { deleteRestaurantTables } from '../../../../../utils/dashboardAPIUtils';
import { fetchRestaurantDashboardReservationDetails } from '../../../DashboardSlice';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const DashboardRestaurantTableInfoList = (props) => {
  const {
    onViewToggle,
    hotelId,
    permissions,
    restaurantDashboardReservationTable,
    obj,
    toggleDrawer,
    restaurantId,
    isFromTables,
    setIsFromTables,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    showLoader = () => {},
  } = props;
  const dispatch = useDispatch();
  const [tableList, setTableList] = useState([]);
  const [filterDataList, setFilterDataList] = useState(RES_TABLE_FILTER);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
    obj: null,
  });

  const onOpenDrawer = (event, type) => {
    if (event) event.stopPropagation();
    toggleDrawer(type, true, selectedValue.obj);
    handleClose();
  };

  useEffect(() => {
    if (isFromTables) {
      setIsFromTables(false);
      onOpenDrawer(null, DASHBOARD_REST_TABLES_INFO_CREATE);
    }
  }, []);

  useEffect(() => {
    setTableList(restaurantDashboardReservationTable);
    setFilteredBaseList(restaurantDashboardReservationTable);
  }, [restaurantDashboardReservationTable]);

  const setSearchText = (searchText) => {
    onsetPage(0);
    if (!searchText) {
      setTableList(filteredBaseList);
      return;
    }
    const filteredRows = filteredBaseList?.filter((item) => {
      return (
        item.exposure.toLowerCase().includes(searchText.toLowerCase()) ||
        item.tableNumber.toString().toLowerCase().includes(searchText.toLowerCase())
      );
    });
    setTableList(filteredRows);
  };

  const filteredRecords = (filters, field) => {
    if (field === 'all') {
      setTableList(restaurantDashboardReservationTable);
      setFilteredBaseList(restaurantDashboardReservationTable);
      RES_TABLE_FILTER[1].subMenu = RES_TABLE_STATUS;
      setFilterDataList(RES_TABLE_FILTER);
    } else if (field === TABLE_STATUS_NOBOOKINGS) {
      const noBookingsFilter = restaurantDashboardReservationTable.filter(
        (currTable) => currTable.status === TABLE_STATUS_VACANT,
      );
      setTableList(noBookingsFilter);
      setFilteredBaseList(noBookingsFilter);
    } else {
      const filterIdWithFields = filterDataList
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((item) => item !== null);
      const filteredRecords = restaurantDashboardReservationTable.filter((item) => {
        const doesFilterSatisfy = filterIdWithFields.map((filter) =>
          filter.id.includes(item[filter.field]),
        );
        return !doesFilterSatisfy.includes(false);
      });
      onsetPage(0);
      setTableList(filteredRecords);
      setFilteredBaseList(filteredRecords);
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      obj: null,
    });
  };

  const handleCellMenuClick = (e, selectRow) => {
    e.preventDefault();
    setSelectedValue({
      id: selectRow.tableNumber,
      name: selectRow.tableNumber,
      title: '',
      description: '',
      status: false,
      anchorEl: e.currentTarget,
      obj: selectRow,
    });
  };

  const onViewDetails = (selectedTable, e) => {
    if (
      e.target.className === 'MuiTableCell-root MuiTableCell-body MuiTableCell-alignLeft' ||
      e.target.className === 'MuiTableCell-root MuiTableCell-body MuiTableCell-alignCenter' ||
      e.target.className === 'd-flex align-content-center px-2' ||
      e.target.className ===
        'vacant-status pill d-flex justify-content-center align-items-center py-2 w-90'
    ) {
      onViewToggle(DASHBOARD_REST_TABLES_INFO_DETAILS, true, selectedTable, obj);
    }
  };

  const onClickDelete = (e) => {
    e.preventDefault();
    setSelectedValue((prev) => ({
      ...prev,
      name: selectedValue.obj.tableNumber,
      title: 'Are you sure you want to delete',
      description: 'This action cannot be reversed.',
      status: true,
      anchorEl: null,
    }));
  };

  const onDelete = async () => {
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const language = lang !== 'en' ? lang : '';

      await deleteRestaurantTables(selectedValue.obj.tableNumber, restaurantId, hotelId, language);
      dispatch(fetchRestaurantDashboardReservationDetails(restaurantId));
      notificationManager('success', 'Table deleted successfully');
      handleClose();
    } catch (error) {
      notificationManager(
        'danger',
        `${
          error?.graphQLErrors ? error?.graphQLErrors?.[0]?.message : 'Error occurred while table'
        }`,
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  return (
    <div className='container pb-2'>
      <div className='py-2 d-flex gap-2'>
        <div className='col px-0 d-flex align-items-center'>
          <Button
            variant='text'
            color='secondary'
            size='large'
            startIcon={<ArrowBackIcon fontSize='medium' />}
            onClick={() => onViewToggle(DASHBOARD_REST_TABLES_VIEW, true, obj)}
          >
            Back
          </Button>
          <span className='page-title'>Tables Info</span>
        </div>
      </div>
      <div className='resv-table-info-list'>
        <div className='mt-4 card shadow'>
          <div className='mt-4 mb-4 group-list-container'>
            <SearchBar
              type={DASHBOARD_REST_TABLES_INFO_CREATE}
              buttonName='Add Table'
              setSearchText={setSearchText}
              onOpenDrawer={onOpenDrawer}
              filterList={filterDataList}
              setFilterDataList={setFilterDataList}
              filteredRecoard={filteredRecords}
              actionMenuItems={[]}
              displayAddOrEdit={
                permissions != null &&
                Object.keys(permissions)?.length > 0 &&
                permissions?.[RBAC_TYPE_HOTEL_RESTAURANT] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
                  ? 'show'
                  : 'hide'
              }
            />
            <div className='row mx-2 d-flex mt-4'>
              {loading ? (
                <div className='pt-4 col-md-12'>
                  <LinearProgressBar />
                </div>
              ) : (
                tableList && (
                  <TableContainer>
                    <Table className='list-table' aria-label='simple table'>
                      <TableHead>
                        <TableRow className='border-white pointer'>
                          <TableCell className='w-15'>Table No</TableCell>
                          <TableCell className='w-15' align='center'>
                            Exposure
                          </TableCell>
                          <TableCell className='w-15' align='center'>
                            Capacity
                          </TableCell>
                          <TableCell className='w-20' align='center'>
                            Bookings
                          </TableCell>
                          <TableCell className='w-10' align='center'>
                            Time Slot
                          </TableCell>
                          <TableCell className='w-15' align='center'>
                            Status
                          </TableCell>
                          <TableCell align='right'></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? tableList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : tableList
                        ).map((item, i) => (
                          <TableRow
                            key={i}
                            className='border-white pointer'
                            onClick={(e) => {
                              onViewDetails(item, e);
                            }}
                          >
                            <TableCell align='left'>{item.tableNumber}</TableCell>
                            <TableCell align='center'>{item.exposure}</TableCell>
                            <TableCell align='center'>{('0' + item.capacity).slice(-2)}</TableCell>
                            <TableCell align='center'>{item.bookingCount}</TableCell>
                            <TableCell align='center'>{item.duration} min</TableCell>
                            <TableCell align='center'>
                              <div className='d-flex align-content-center px-2'>
                                <div
                                  className={`${item.className} pill d-flex justify-content-center align-items-center py-2 w-90`}
                                >
                                  <span className='ms-1'>{item.status}</span>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell>
                              <Button
                                aria-controls='simple-menu'
                                aria-haspopup='true'
                                onClick={(e) => {
                                  handleCellMenuClick(e, item);
                                }}
                              >
                                <MoreHoriz />
                              </Button>
                              <Menu
                                id={i}
                                anchorEl={selectedValue?.anchorEl}
                                disableRestoreFocus
                                MenuListProps={{ autoFocusItem: false }}
                                keepMounted
                                open={
                                  Boolean(selectedValue.anchorEl) &&
                                  selectedValue.id === item.tableNumber
                                }
                                onClose={handleClose}
                                className='shadow'
                              >
                                <MenuItem
                                  className='pe-4'
                                  onClick={(e) =>
                                    onOpenDrawer(e, DASHBOARD_REST_TABLES_INFO_CREATE)
                                  }
                                >
                                  <CreateIcon className='me-2 action-menu-icon' />
                                  Edit
                                </MenuItem>
                                <MenuItem
                                  className='pe-4'
                                  onClick={() =>
                                    onViewToggle(
                                      DASHBOARD_REST_TABLES_INFO_DETAILS,
                                      true,
                                      selectedValue.obj,
                                      obj,
                                    )
                                  }
                                >
                                  <VisibilityIcon className='me-2 action-menu-icon' />
                                  View
                                </MenuItem>
                                <MenuItem className='pe-4' onClick={(e) => onClickDelete(e)}>
                                  <DeleteForeverIcon className='me-2 action-menu-icon' />
                                  Delete
                                </MenuItem>
                              </Menu>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter>
                        <TableRow className='paginator'>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                            count={tableList.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              inputProps: { 'aria-label': 'rows per page' },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                )
              )}
            </div>
          </div>
        </div>
      </div>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDelete}
          onDeleteCancel={handleClose}
        />
      )}
    </div>
  );
};

export default DashboardRestaurantTableInfoList;
